var render = function render(){var _vm=this,_c=_vm._self._c;return _c('pay-order-item',{key:[_vm.tabIndex, _vm.pageType].join(''),attrs:{"type":_vm.tabIndex,"pageType":_vm.pageType},on:{"tab":_vm.onTab,"pageTypeChange":_vm.onPageTypeChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }